export default function Timeline()
{
    <div class=" w-full h-20 bg-[#c59ad9] ">
        
    </div>;
};